import { resolveComponent, createBlock, openBlock, createSlots, renderList, withCtx, renderSlot, normalizeProps, guardReactiveProps } from "vue";
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const _sfc_main = {};
function _sfc_render(_ctx, _cache) {
  const _component_b_boolean = resolveComponent("b-boolean");
  return openBlock(), createBlock(_component_b_boolean, {
    class: "b-checkbox",
    type: "checkbox"
  }, createSlots({ _: 2 }, [
    renderList(_ctx.$slots, (_, slotName) => {
      return {
        name: slotName,
        fn: withCtx((slotProps) => [
          renderSlot(_ctx.$slots, slotName, normalizeProps(guardReactiveProps(slotProps || {})))
        ])
      };
    })
  ]), 1024);
}
const BanzaCheckbox = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  BanzaCheckbox as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQmFuemFDaGVja2JveC52dWUuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhc2UvQmFuemFDaGVja2JveC52dWUiXSwic291cmNlc0NvbnRlbnQiOlsiPHRlbXBsYXRlPlxuXHQ8Yi1ib29sZWFuXG5cdFx0Y2xhc3M9XCJiLWNoZWNrYm94XCJcblx0XHR0eXBlPVwiY2hlY2tib3hcIj5cblx0XHQ8dGVtcGxhdGVcblx0XHRcdHYtZm9yPVwiKF8sIHNsb3ROYW1lKSBpbiAkc2xvdHNcIlxuXHRcdFx0I1tzbG90TmFtZV09XCJzbG90UHJvcHNcIj5cblx0XHRcdDxzbG90XG5cdFx0XHRcdDpuYW1lPVwic2xvdE5hbWVcIlxuXHRcdFx0XHR2LWJpbmQ9XCJzbG90UHJvcHMgfHwge31cIiAvPlxuXHRcdDwvdGVtcGxhdGU+XG5cdDwvYi1ib29sZWFuPlxuPC90ZW1wbGF0ZT5cbiJdLCJuYW1lcyI6WyJfY3JlYXRlQmxvY2siLCJfd2l0aEN0eCJdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFFRSxtQkFBa0IsR0FBQUEsWUFBQSxzQkFBQTtBQUFBLElBQ2xCLE9BQWU7QUFBQTtpQkFFZ0IsRUFBQSxHQUFBLEtBQUE7QUFBQTs7UUFFOUIsTUFBQTtBQUFBLFlBRTRCQyxRQUFBLENBQUEsY0FEWjtBQUFBOzs7Ozs7OyJ9
